module.exports = __webpack_public_path__ + "static/scale-model-of-chicago-chariot-tours-in-chicago-illinois-cc8e17ece4ac0ab4a5b3e0bd1f22568b.png";